import firebase from './Settings';
// Firebase references
const db = firebase.firestore();

// Collections
export const stories = db.collection('stories');
export const users = db.collection('users');

